import React, { useEffect, useRef } from 'react';

const FileViewer = () => {
  // Extract the file URL from the query parameters.
  const queryParams = new URLSearchParams(window.location.search);
  const fileUrl = queryParams.get('url');

  const iframeRef = useRef(null);
  const pollIntervalRef = useRef(null);
  const printingStartedRef = useRef(false);

  useEffect(() => {
    const closeWindow = () => {
      console.log('Closing window...');
      window.close();
    };

    // afterprint event listener
    const handleAfterPrint = () => {
      console.log('afterprint event fired');
      setTimeout(closeWindow, 300);
    };
    window.addEventListener('afterprint', handleAfterPrint);
    console.log('Added afterprint event listener on window');

    // Media query listener as a fallback
    const mediaQueryList = window.matchMedia('print');
    const mediaQueryListener = (mqlEvent) => {
      console.log('Media query listener fired, mql.matches:', mqlEvent.matches);
      if (!mqlEvent.matches) {
        setTimeout(closeWindow, 300);
      }
    };
    mediaQueryList.addListener(mediaQueryListener);
    console.log('Added media query listener for print mode');

    // Focus event listener as another fallback
    const handleFocus = () => {
      console.log('Focus event fired');
      setTimeout(closeWindow, 300);
    };
    window.addEventListener('focus', handleFocus, { once: true });
    console.log('Added one-time focus event listener on window');

    // Cleanup on unmount.
    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
      mediaQueryList.removeListener(mediaQueryListener);
      window.removeEventListener('focus', handleFocus);
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
      }
      console.log('Removed all print event listeners');
    };
  }, []);

  // Start polling after a delay once printing is initiated.
  const startPolling = () => {
    pollIntervalRef.current = setInterval(() => {
      console.log(
        'Polling: visibilityState:',
        document.visibilityState,
        'hasFocus:',
        document.hasFocus()
      );
      // Only act if printing was triggered
      if (
        printingStartedRef.current &&
        document.visibilityState === 'visible' &&
        document.hasFocus()
      ) {
        console.log('Polling condition met; closing window.');
        clearInterval(pollIntervalRef.current);
        window.close();
      }
    }, 500);
  };

  const handleIframeLoad = () => {
    if (iframeRef.current) {
      try {
        const iframeWindow = iframeRef.current.contentWindow;
        console.log('Iframe loaded; triggering print on iframe content.');
        printingStartedRef.current = true;
        iframeWindow.focus();
        iframeWindow.print();
      } catch (error) {
        console.error(
          'Error printing iframe, falling back to window.print():',
          error
        );
        printingStartedRef.current = true;
        window.focus();
        window.print();
      }
      // Delay starting the polling by 1 second to give the print dialog time to open.
      setTimeout(() => {
        console.log('Starting polling after print is triggered.');
        startPolling();
      }, 1000);
    }
  };

  return (
    <div className="flex flex-col h-screen">
      <div className="flex-grow">
        {fileUrl ? (
          <iframe
            src={fileUrl}
            title="File Viewer"
            className="w-full h-full"
            ref={iframeRef}
            onLoad={handleIframeLoad}
          />
        ) : (
          <div className="flex items-center justify-center h-full">
            <p className="text-xl">No file URL provided.</p>
          </div>
        )}
      </div>
      {/* Manual fallback: user can click if auto-close fails */}
      <button
        onClick={() => window.close()}
        className="p-4 bg-red-500 text-white"
      >
        Close Window
      </button>
    </div>
  );
};

export default FileViewer;
